import Vue from 'vue';
import App from './App.vue';
import './plugins/element.js';
import router from './router';
import * as echarts from 'echarts';
import noCart from './components/noCart/index.vue';
import JsonExcel from 'vue-json-excel';
import * as filters from './filter/filters';

import http from './http';
import userList from './userlist';
import { getStorageUrl } from './storage';
import md5 from 'js-md5';
import sha256 from 'js-sha256';

Vue.prototype.$md5 = md5;
Vue.prototype.$sha256 = sha256;
// axios.defaults.baseURL = 'https://kapi.nengwing.com/'  // api 即上面 vue.config.js 中配置的地址
Vue.prototype.$http = http;
Vue.prototype.$userList = userList;
Vue.prototype.$getStorageUrl = getStorageUrl;
//第二步：使用 Vue.component('组件名称',创建出来的组件模板对象)
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]); //插入过滤器名和对应方法
});
Vue.component('noCart', noCart);

Vue.component('downloadExcel', JsonExcel);

console.log(process.env.VUE_APP_URL);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
new Vue({
  router,
  data: {
    headName: [],
    setheadName() {},
  },
  render: (h) => h(App),
}).$mount('#app');
